module.exports = __webpack_public_path__ + "site/img/213.47f20d24.jpg";